import * as React from 'react';
export const mbwaySvg = React.forwardRef(function mbwaySvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#2E333A',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: 'red',
      d: 'M7.792 26.001h16.417c1.885 0 1.904-1.729 1.712-2.759-.105-.694-1.235-.687-1.36 0v.804a.657.657 0 0 1-.642.669H8.079c-.352 0-.64-.301-.64-.67v-.803c-.125-.687-1.256-.694-1.36 0-.192 1.03-.175 2.759 1.713 2.759Zm15.052-20H9.216c-.895 0-1.628.407-1.627 1.393v.881c0 1.172 1.503 1.18 1.503-.025v-.458a.532.532 0 0 1 .52-.542h12.763a.533.533 0 0 1 .372.163.532.532 0 0 1 .15.379v.468c0 1.2 1.574 1.204 1.574-.008v-.858c0-.986-.732-1.394-1.627-1.394Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      fillRule: 'evenodd',
      d: 'M24.15 15.853a2.629 2.629 0 0 1 1.492 2.349c0 1.444-1.212 2.625-2.692 2.625h-4.147a.7.7 0 0 1-.706-.687v-8.22c0-.397.312-.722.693-.722h3.455c1.454 0 2.644 1.238 2.644 2.751a2.8 2.8 0 0 1-.739 1.904Zm-3.096-.67h1.318v-.015c.6-.096 1.062-.639 1.062-1.29 0-.717-.562-1.304-1.252-1.304h-2.653v6.822h3.364c.712 0 1.294-.607 1.294-1.348 0-.741-.583-1.347-1.294-1.347h-.521l-1.318-.003a.745.745 0 0 1-.727-.757c0-.417.327-.758.727-.758Zm-3.616 4.824a.858.858 0 0 1-.74.954.841.841 0 0 1-.915-.771l-.683-6.538-2.416 6.393-.003.006-.006.017-.006.013v.004l-.006.013-.01.02-.003.007-.006.012a.868.868 0 0 1-.171.234l-.015.015a.822.822 0 0 1-.144.106l-.004.001-.016.01-.015.008-.006.004-.02.008-.01.005-.01.004-.008.005-.016.006-.013.005-.01.004a.813.813 0 0 1-.25.05h-.061a.802.802 0 0 1-.272-.059l-.012-.005-.013-.005-.012-.005-.008-.005-.01-.003-.015-.01-.015-.007-.014-.008-.008-.004a.839.839 0 0 1-.127-.093l-.004-.002-.027-.025a.856.856 0 0 1-.022-.021l-.02-.023a.992.992 0 0 1-.025-.029l-.002-.003a.858.858 0 0 1-.088-.133l-.005-.007-.006-.013-.009-.019-.002-.005-.005-.01-.005-.01-.004-.01-.005-.01-.004-.012-.006-.015-2.418-6.398-.682 6.538a.84.84 0 0 1-.09.317.841.841 0 0 1-.207.259.84.84 0 0 1-.29.159.842.842 0 0 1-.328.035.859.859 0 0 1-.74-.954l.804-7.708v-.005a1.459 1.459 0 0 1 .689-1.088c.229-.135.491-.201.757-.19h.002c.09.004.175.016.253.034.43.105.795.417.967.872l2.06 5.446 2.056-5.446c.172-.455.537-.767.967-.872a1.378 1.378 0 0 1 1.546.726c.083.162.136.338.155.518v.004l.807 7.71Z',
      clipRule: 'evenodd',
    }),
  );
});
mbwaySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var mbway = {
  category: 'brand',
  colorable: false,
  name: 'mbway',
  svg: mbwaySvg,
};
